module.exports = __webpack_public_path__ + "static/media/_F4-Entity__Framework__Core.dd18a1d8.png";